import { useNavigate, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { AppButton } from 'components/AppButton';
import { FloatingBlurredLayout } from 'components/layouts';
import { PATHS } from 'config/paths';
import { TrackingEvents, useTrackingDispatch } from 'modules/analytics';
import { getTrans } from 'modules/i18n';
import { ModalName, useModal } from 'modules/modal';
import { GeneralStatus } from 'modules/status-badge';
import { useWeekDetails } from '../hooks';
import { isMaxShiftsReached } from '../utils';

export const FloatingButtons = () => {
  const { weekId } = useParams();
  const navigate = useNavigate();
  const { weekDetails, isLoading } = useWeekDetails();
  const { open } = useModal();
  const dispatch = useTrackingDispatch();

  const renderSupportButton = () => (
    <AppButton
      color="primary"
      sx={{ width: 160 }}
      onClick={() => navigate(`${PATHS.account}/${PATHS.contactZenjob}`)}
    >
      {getTrans('weekDetailsPage.button.support')}
    </AppButton>
  );

  if (isLoading) {
    return (
      <FloatingBlurredLayout>{renderSupportButton()}</FloatingBlurredLayout>
    );
  }

  if (!weekId || !weekDetails) return null;

  const { assignments } = weekDetails;
  const assignment = assignments[weekId];

  if (!assignment) return null;
  const {
    weekStatus,
    reportedMinutes,
    expectedMinutes,
    reportedReasonMinutes
  } = assignment;

  const isWeekOpen = weekStatus === GeneralStatus.OPEN;

  const isWorkedLessThenExpected =
    reportedMinutes + reportedReasonMinutes < expectedMinutes;

  const onButtonClick = () => {
    dispatch({
      type: TrackingEvents.INIT_SHIFT,
      payload: { id: uuidv4(), weekId }
    });

    open(ModalName.addShift);
  };

  return (
    <FloatingBlurredLayout>
      {isWeekOpen ? (
        <AppButton
          color="primary"
          variant={isWorkedLessThenExpected ? 'contained' : 'outlined'}
          sx={{ width: 160 }}
          onClick={onButtonClick}
          disabled={isMaxShiftsReached(assignment?.shifts?.length)}
        >
          {getTrans('weekDetailsPage.button.addShift')}
        </AppButton>
      ) : (
        renderSupportButton()
      )}
    </FloatingBlurredLayout>
  );
};
